

import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import { show_meeting_data } from "../../api/User";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import "../Admin/table.css";
import Button from "@mui/material/Button";
import TablePagination from '@mui/material/TablePagination';
import { FirstPage, LastPage, KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import Swal from 'sweetalert2';
import loader from "../../Images/ajax-loader.gif";

const ViewMeetingComponent = (meeting_type) => {
  const [token, setToken] = useState(sessionStorage.getItem("token") || "");
  const role_id = sessionStorage.getItem("role_id");
  const [meetingData, setMeetingData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await show_meeting_data(token, meeting_type);
      if (res.status === "success") {
        const formattedData = res.data.map((item) => {
          const [hours, minutes] = item.sabha_start_time.split(':');
          const formattedStartTime = `${hours}:${minutes}`;
          return {
            ...item,
            sabha_date: new Date(item.sabha_date).toISOString().split("T")[0],
            sabha_start_time: formattedStartTime,
          };
        });
        setMeetingData(formattedData);
        setLoading(false);
      } else {
        setLoading(false);
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
        setLoading(false);
      console.error("Error fetching data:", error);
      toast.error("An error occurred while fetching data.", { autoClose: 1000 });
    }
  };

  const openBase64File = (base64String, fileName) => {
    if (!base64String) {
      Swal.fire({
        icon: "error",
        title: "File Not Uploaded",
        text: "No file available for this entry.",
        confirmButtonText: "OK",
      });
      return;
    }

    const lowerName = fileName.toLowerCase();

    let mimeType = "";
    if (lowerName.endsWith(".pdf")) {
      mimeType = "application/pdf";
    } else if (lowerName.endsWith(".doc") || lowerName.endsWith(".docx")) {
      mimeType = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    } else {
      Swal.fire({
        icon: "warning",
        title: "Unsupported File Type",
        text: "This file format is not supported for downloading.",
        confirmButtonText: "OK",
      });
      return;
    }

    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName || "download";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const paginatedData = meetingData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);


  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <style>
        {`
          .MuiTablePagination-actions svg {
            visibility: visible !important;
            fill: #212128;  
          }
        `}
      </style>
      <div className="container-fluid" style={{ height: "91vh" }}>
        <div
    id="loading-coupon"
    style={{
      display: loading ? "flex" : "none",
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(255,255,255,0.7)",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
    }}
  >
    <img id="loading-image" src={loader} alt="Loading..." />
  </div>
        <div style={{ overflowX: "auto", maxHeight: "70vh", marginTop: "20px" }}>
          <Table aria-label="simple table">
            <TableHead style={{ position: "sticky", top: 0, zIndex: 1, backgroundColor: "rgb(232 233 246)", whiteSpace: "nowrap" }} >
              <TableRow>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center"> SR NO.</TableCell>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center"> DISTRICT</TableCell>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center"> BLOCK</TableCell>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center"> GRAM PANCHAYAT</TableCell>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center"> DATE</TableCell>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center"> TIME</TableCell>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center"> PRESIDING  OFFICER NAME</TableCell>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center"> PRESIDING  OFFICER MOBILE</TableCell>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center"> PRESIDING  OFFICER DESIGNATION</TableCell>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center"> VENUE</TableCell>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center"> AGENDA</TableCell>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center"> Meeting Notice</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={11} align="center"> No data found </TableCell>
                </TableRow>
              ) : (
                paginatedData.map((row, index) => (
                  <TableRow key={row.id}>
                    <TableCell align="center" style={{ whiteSpace: "nowrap" }}>{index + 1 + (page * rowsPerPage)}</TableCell>
                    <TableCell align="center" style={{ whiteSpace: "nowrap" }}>{row.district}</TableCell>
                    <TableCell align="center" style={{ whiteSpace: "nowrap" }}>{row.block}</TableCell>
                    <TableCell align="center" style={{ whiteSpace: "nowrap" }}>{row.gram_panchayat}</TableCell>
                    <TableCell align="center" style={{ whiteSpace: "nowrap" }}>{row.sabha_date}</TableCell>
                    <TableCell align="center" style={{ whiteSpace: "nowrap" }}>{row.sabha_start_time}</TableCell>
                    <TableCell align="center" style={{ whiteSpace: "nowrap" }}>{row.presiding_officer_name}</TableCell>
                    <TableCell align="center" style={{ whiteSpace: "nowrap" }}>{row.presiding_officer_mobile}</TableCell>
                    <TableCell align="center" style={{ whiteSpace: "nowrap" }}>{row.presiding_officer_designation}</TableCell>
                    <TableCell align="center" style={{ whiteSpace: "nowrap" }}>{row.venue}</TableCell>
                    <TableCell align="center" className="custom-class">
                      {row.agenda == null || "" ? (
                        "-----"
                      ) : (
                        <Button variant="contained" sx={{ fontSize: 15, backgroundColor: "#4763E430", color: "#4763E4", "&:hover": { backgroundColor: "#4763E4", color: "#fff" }, }}
                          onClick={() => openBase64File(row.agenda_base64, row.agenda)}>View</Button>
                      )}
                    </TableCell>
                    <TableCell align="center" className="custom-class">
                      {row.meeting_notice_upload == null || "" ? (
                        "-----"
                      ) : (
                        <Button variant="contained" sx={{ fontSize: 15, backgroundColor: "#4763E430", color: "#4763E4", "&:hover": { backgroundColor: "#4763E4", color: "#fff" }, }}
                          onClick={() => openBase64File(row.meeting_notice_upload_base64, row.meeting_notice_upload)}>View</Button>
                      )}
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </div>
        <TablePagination rowsPerPageOptions={[5, 10, 25]} component="div" count={meetingData.length} rowsPerPage={rowsPerPage} page={page} onPageChange={handleChangePage} onRowsPerPageChange={handleChangeRowsPerPage} showFirstButton showLastButton components={{ FirstPageIcon: FirstPage, LastPageIcon: LastPage, NextPageIcon: KeyboardArrowRight, BackPageIcon: KeyboardArrowLeft, }} />
        <ToastContainer />
      </div>
    </>
  );
};

export default ViewMeetingComponent;
